<template>
  <b-container fluid>
    <b-row>
      <b-col lg="12" sm="12">
        <iq-card>
          <template v-slot:body>
            <b-row class="details">
                <b-col lg="12" sm="12">
                    <b-row>
                        <b-col xs="12" sm="12" md="8" class="text-left mb-2">
                            <h5>{{ (currentLocale === 'en') ? trainerProfile.name + "'s" : trainerProfile.name_bn + ' এর ' }} {{ $t('child_admission_management.profile') + ' ' + $t('globalTrans.details') }}</h5>
                        </b-col>
                        <b-col xs="12" sm="12" md="4" class="text-right mb-2">
                            <b-button-group>
                                <b-button @click="pdfExport()" variant="success">{{  $t('globalTrans.export_pdf') }}</b-button>
                            </b-button-group>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col lg="12" sm="12">
                            <div style="font-size:18px; background-color: #17a2b8;border-radius:5px" class="p-1 mb-2">
                                <h5 class="text-white text-center"> {{ $t('educational_management.instructor_identity') }}</h5>
                            </div>
                            <b-row>
                                <b-col md=2>
                                    <b-img width='150px' height="150px" :src="url+'download-attachment?file=uploads/trainer-profile-original/' + trainerProfile.photo" alt="Candidate Image"></b-img>
                                   <!-- <div style="float: right; width: 90px;">
                                        <a :href="url + 'download-attachment?file=uploads/trainer-profile-original/' + trainerProfile.photo" title="Candidate Image Download">Attachment Download <i class="ri-download-cloud-fill"></i></a>
                                    </div>-->
                                </b-col>
                                <b-col md=10>
                                    <b-table striped small bordered hover :items="candidateIndentify" thead-class="hidden_header"></b-table>
                                </b-col>
                            </b-row>
                            <div style="font-size:18px; background-color: #17a2b8;border-radius:5px" class="p-1 mb-2">
                                <h5 class="text-white text-center"> {{ $t('child_admission_management.per_address') }}</h5>
                            </div>
                            <b-row class="mt-2">
                                <b-col md=12>
                                    <b-table striped small bordered hover :items="permanentAddress" thead-class="hidden_header"></b-table>
                                </b-col>
                            </b-row>
                            <div style="font-size:18px; background-color: #17a2b8;border-radius:5px" class="p-1 mb-2">
                                <h5 class="text-white text-center"> {{ $t('child_admission_management.present_address') }}</h5>
                            </div>
                            <b-row>
                                <b-col md=12>
                                    <b-table striped small bordered hover :items="presentAddress" thead-class="hidden_header"></b-table>
                                </b-col>
                            </b-row>
                        </b-col>
                    </b-row>
                    <div style="font-size:18px; background-color: #17a2b8;border-radius:5px" class="p-1 mb-2">
                        <h5 class="text-white text-center"> {{ $t('educational_management.academic_inf') }}</h5>
                    </div>
                    <b-row>
                        <b-col lg="12" sm="12">
                            <b-row>
                                <b-col md=12>
                                    <b-table-simple striped bordered small hover style="margin-bottom: 0rem !important">
                                        <tbody>
                                            <b-tr>
                                                <b-td>{{ $t('educational_management.highest_degree') }}</b-td>
                                                <b-td>{{ getHighestEduQualification(trainerProfile.highest_degree_id) }}</b-td>
                                                <b-td>{{ $t('educational_management.board_university') }}</b-td>
                                                <b-td>{{ trainerProfile.board_university_name }}</b-td>
                                            </b-tr>
                                        </tbody>
                                    </b-table-simple>
                                </b-col>
                            </b-row>
                        </b-col>
                    </b-row>
                    <div style="font-size:18px; background-color: #17a2b8;border-radius:5px" class="p-1 mb-2 mt-2">
                        <h5 class="text-white text-center"> {{ $t('educational_management.profession_info') }}</h5>
                    </div>
                     <b-row>
                        <b-col lg="12" sm="12">
                            <b-row>
                                <b-col md=12>
                                    <b-table-simple striped bordered small hover style="margin-bottom: 0rem !important">
                                        <tbody>
                                            <b-tr>
                                                <b-td>{{ $t('globalTrans.organization') }}</b-td>
                                                <b-td>{{ trainerProfile.org_name ? trainerProfile.org_name : 'N/A' }}</b-td>
                                                <b-td>{{ $t('educational_management.designation') }}</b-td>
                                                <b-td>{{ getDesignation(trainerProfile.designation_id) }}</b-td>
                                            </b-tr>
                                            <b-tr>
                                                <b-td>{{ $t('educational_management.service_id') }}</b-td>
                                                <b-td>{{ trainerProfile.employee_id}}</b-td>
                                                <b-td>{{ $t('educational_management.pay_grade') }}</b-td>
                                                <b-td>{{ getPayGrade(trainerProfile.pay_grade_id) }}</b-td>
                                            </b-tr>
                                             <b-tr>
                                                <b-td>{{ $t('child_admission_management.email') }}</b-td>
                                                <b-td>{{ trainerProfile.email }}</b-td>
                                                <b-td>{{ $t('child_admission_management.religion') }}</b-td>
                                                <b-td>{{ trainerProfile.religion_id ? getReligionName(trainerProfile.religion_id) : 'N/A' }}</b-td>
                                            </b-tr>
                                            <b-tr>
                                                <b-td>{{ $t('educational_management.mobile_no') }}</b-td>
                                                <b-td>{{ trainerProfile.mobile_no | mobileNumber }}</b-td>
                                                <b-td>{{ $t('educational_management.blood_group') }}</b-td>
                                                <b-td>{{ trainerProfile.blood_group_id? getBloodGroup(trainerProfile.blood_group_id) : 'N/A' }}</b-td>
                                            </b-tr>
                                            <b-tr>
                                                <b-td>{{ $t('educational_management.nid') }}</b-td>
                                                <b-td>{{ trainerProfile.nid | mobileNumber }}</b-td>
                                                <b-td>{{ $t('trainer_trainee.expertise_sector') }}</b-td>
                                                <b-td>{{currentLocale == 'en'? trainerProfile.expertise_sector : trainerProfile.expertise_sector_bn}}</b-td>
                                            </b-tr>
                                        </tbody>
                                    </b-table-simple>
                                </b-col>
                            </b-row>
                        </b-col>
                    </b-row>
                </b-col>
            </b-row>
          </template>
        </iq-card>
      </b-col>
    </b-row>
  </b-container>
</template>
<script>
import { core } from '@/config/pluginInit'
import Custom from '../../../../../store/custom'
import ExportPdf from './export-pdf'
import { trainingElearningServiceBaseUrl } from '@/config/api_config'

export default {
  props: ['id', 'url'],
  components: {
  },
  data () {
    return {
      trainerProfile: {
      },
      genderList: [
          { value: 1, text_en: 'Male', text_bn: 'পুরুষ' },
          { value: 2, text_en: 'Female', text_bn: 'মহিলা' }
      ],
      religionList: [
        { value: 1, text: this.$t('educational_management.islam') },
        { value: 2, text: this.$t('educational_management.hindu') },
        { value: 3, text: this.$t('educational_management.christian') },
        { value: 4, text: this.$t('educational_management.buddhist') }
      ],
      bloodGroupList: [
          { value: 1, text_en: 'A+', text_bn: 'এ+' },
          { value: 2, text_en: 'A-', text_bn: 'এ-' },
          { value: 3, text_en: 'B+', text_bn: 'বি+' },
          { value: 4, text_en: 'B-', text_bn: 'বি-' },
          { value: 5, text_en: 'O+', text_bn: 'ও+' },
          { value: 6, text_en: '0-', text_bn: 'ও-' },
          { value: 7, text_en: 'AB+', text_bn: 'এবি+' },
          { value: 8, text_en: 'AB-', text_bn: 'এবি-' }
      ]
    }
  },
  created () {
    if (this.id) {
        const tmp = this.getTrainerProfileData()
        this.trainerProfile = tmp
    }
  },
  mounted () {
    core.index()
  },
  computed: {
    candidateIndentify () {
      return [
        { key: this.$t('child_admission_management.name'), val: this.$i18n.locale === 'en' ? this.trainerProfile.name : this.trainerProfile.name_bn },
        { key: this.$t('globalTrans.gender'), val: this.getGenderName(this.trainerProfile.gender) },
        { key: this.$t('child_admission_management.father_name'), val: this.$i18n.locale === 'en' ? this.trainerProfile.father_name : this.trainerProfile.father_name_bn },
        { key: this.$t('child_admission_management.mother_name'), val: this.$i18n.locale === 'en' ? this.trainerProfile.mother_name : this.trainerProfile.mother_name_bn }
      ]
    },
    permanentAddress () {
      return [
        { key: this.$t('educational_management.area_type'), val: this.getAreaType(this.trainerProfile.per_area_id), key1: this.$t('org_pro_division.division'), val1: this.getDivisionName(this.trainerProfile.per_division_id) },
        { key: this.$t('educational_management.name_of_district'), val: this.getDistrictName(this.trainerProfile.per_district_id), key1: this.$t('org_pro_upazilla.upazilla'), val1: this.trainerProfile.per_upazila_id ? this.getUpazilaName(this.trainerProfile.per_upazila_id) : 'N/A' },
        { key: this.$t('org_pro_union.union'), val: this.trainerProfile.per_union_id ? this.getUnionName(this.trainerProfile.per_union_id) : 'N/A', key1: this.$t('org_pro.city_corporation'), val1: this.trainerProfile.per_city_corporation_id ? this.getCityCorpName(this.trainerProfile.per_city_corporation_id) : 'N/A' },
        { key: this.$t('educational_management.pourosoba'), val: this.trainerProfile.per_paurasabha_id ? this.getPourosobaName(this.trainerProfile.per_paurasabha_id) : 'N/A', key1: this.$t('org_pro.ward'), val1: this.trainerProfile.per_ward_id ? this.getWardName(this.trainerProfile.per_ward_id) : 'N/A' },
        { key: this.$t('educational_management.address_details'), val: this.$i18n.locale === 'en' ? this.trainerProfile.per_address : this.trainerProfile.per_address_bn }
      ]
    },
    presentAddress () {
      return [
        { key: this.$t('org_pro.area_type'), val: this.getAreaType(this.trainerProfile.pre_area_id), key1: this.$t('org_pro_division.division'), val1: this.getDivisionName(this.trainerProfile.pre_division_id) },
        { key: this.$t('org_pro_district.district'), val: this.getDistrictName(this.trainerProfile.pre_district_id), key1: this.$t('org_pro_upazilla.upazilla'), val1: this.trainerProfile.pre_upazila_id ? this.getUpazilaName(this.trainerProfile.pre_upazila_id) : 'N/A' },
        { key: this.$t('org_pro_union.union'), val: this.trainerProfile.pre_union_id ? this.getUnionName(this.trainerProfile.pre_union_id) : 'N/A', key1: this.$t('org_pro.city_corporation'), val1: this.trainerProfile.pre_city_corporation_id ? this.getCityCorpName(this.trainerProfile.pre_city_corporation_id) : 'N/A' },
        { key: this.$t('educational_management.pourosoba'), val: this.trainerProfile.pre_paurasabha_id ? this.getPourosobaName(this.trainerProfile.pre_paurasabha_id) : 'N/A', key1: this.$t('org_pro.ward'), val1: this.trainerProfile.pre_ward_id ? this.getWardName(this.trainerProfile.pre_ward_id) : 'N/A' },
        { key: this.$t('educational_management.address_details'), val: this.$i18n.locale === 'en' ? this.trainerProfile.pre_address : this.trainerProfile.pre_address_bn }
      ]
    },
    currentLocale () {
      return this.$i18n.locale
    }
  },
  watch: {
  },
  methods: {
    getGenderName (Id) {
        const tmpData = this.genderList.find(item => item.value === parseInt(Id))
        if (this.$i18n.locale === 'bn') {
            return tmpData.text_bn
        } else {
            return tmpData.text_en
        }
    },
    getBloodGroup (Id) {
        const tmpData = this.bloodGroupList.find(item => item.value === parseInt(Id))
        if (this.$i18n.locale === 'bn') {
            return tmpData.text_bn
        } else {
            return tmpData.text_en
        }
    },
    getReligionName (Id) {
        const tmpData = this.religionList.find(item => item.value === Id)
        return tmpData.text
    },
    getWardName (Id) {
        const tmpData = this.$store.state.commonObj.wardList.find(item => item.value === Id && item.status === 0)
        if (this.$i18n.locale === 'bn') {
            return tmpData.text_bn
        } else {
            return tmpData.text_en
        }
    },
    getUnionName (Id) {
        const tmpData = this.$store.state.commonObj.unionList.find(item => item.value === Id && item.status === 0)
        if (this.$i18n.locale === 'bn') {
            return tmpData.text_bn
        } else {
            return tmpData.text_en
        }
    },
    getUpazilaName (Id) {
        const tmpData = this.$store.state.commonObj.upazilaList.find(item => item.value === Id && item.status === 0)
        if (this.$i18n.locale === 'bn') {
            return tmpData.text_bn
        } else {
            return tmpData.text_en
        }
    },
    getDivisionName (Id) {
        const tmpData = this.$store.state.commonObj.divisionList.find(item => item.value === Id && item.status === 0)
        if (this.$i18n.locale === 'bn') {
            return tmpData.text_bn
        } else {
            return tmpData.text_en
        }
    },
    getPourosobaName (Id) {
        const tmpData = this.$store.state.commonObj.pauroshobaList.find(item => item.value === Id && item.status === 0)
        if (this.$i18n.locale === 'bn') {
            return tmpData.text_bn
        } else {
            return tmpData.text_en
        }
    },
    getCityCorpName (Id) {
        const tmpData = this.$store.state.commonObj.cityCorporationList.find(item => item.value === Id && item.status === 0)
        if (this.$i18n.locale === 'bn') {
            return tmpData.text_bn
        } else {
            return tmpData.text_en
        }
    },
    getDistrictName (Id) {
        const tmpData = this.$store.state.commonObj.districtList.find(item => item.value === Id && item.status === 0)
        if (this.$i18n.locale === 'bn') {
            return tmpData.text_bn
        } else {
            return tmpData.text_en
        }
    },
    getAreaType (Id) {
        const tmpData = Custom.wardTypeList.find(item => item.id === Id)
        if (this.$i18n.locale === 'bn') {
            return tmpData.name_bn
        } else {
            return tmpData.name
        }
    },
    getInstituteType (Id) {
        const tmpData = this.$store.state.commonObj.officeTypeList.find(item => item.value === Id && item.status === 0)
        if (this.$i18n.locale === 'bn') {
            return tmpData.text_bn
        } else {
            return tmpData.text_en
        }
    },
    getHighestEduQualification (Id) {
        const highestQualificationObj = this.$store.state.TrainingElearning.commonObj.eduQualificationList.find(eduQualification => eduQualification.status === 1 && eduQualification.value === Id)
        if (this.$i18n.locale === 'bn') {
            return highestQualificationObj.text_bn
        } else {
            return highestQualificationObj.text_en
        }
    },
    getPayGrade (Id) {
        const gradeObj = this.$store.state.TrainingElearning.commonObj.gradeList.find(grade => grade.status === 1 && grade.value === Id)
        if (this.$i18n.locale === 'bn') {
            return gradeObj.text_bn
        } else {
            return gradeObj.text_en
        }
    },
    getDesignation (designationId) {
      const designationObj = this.$store.state.TrainingElearning.commonObj.designationList.find(item => item.value === designationId)
      if (this.$i18n.locale === 'bn') {
        return designationObj.text_bn
      } else {
        return designationObj.text_en
      }
    },
    getTrainerProfileData () {
        const tmpData = this.$store.state.list.find(item => item.id === parseInt(this.id))
        return JSON.parse(JSON.stringify(tmpData))
    },
    pdfExport () {
        const reportTitle = this.$t('trainer_trainee.trainers') + ' ' + this.$t('globalTrans.details')
        ExportPdf.exportPdfDetails(trainingElearningServiceBaseUrl, 'config/report-heading/detail', 4, reportTitle, this.trainerProfile, this)
    }
  }
}
</script>
<style lang="scss">
    .details {
    h5 {
      color: green !important;
      font-size: 20px !important;
    }
    .table-bordered td:nth-child(2n+1) {
      font-weight: 700;
    }
  }
  .hidden_header {
    display: none
  }
  [dir=ltr][mode=light] .card-body {
    flex: 1 1 auto;
    min-height: 1px;
    padding: 10px;
  }
</style>
